// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GemReportExtended } from '../../../assets/icons/extended/entities/gem-report.svg?react';
import { createIcons } from '../../Icon';
const GemReportIcon = /* @__PURE__ */ createIcons('GemReport', {
    extended: GemReportExtended
});
GemReportIcon.supportedTypes = ['extended'];
GemReportIcon.category = 'entities';
export default GemReportIcon;
